var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaleTips1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    transform: "translate(-43 -199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_41",
    "data-name": "Polygon 41",
    d: "M56.843,9.117a10,10,0,0,1,15.315,0l.028.033a10,10,0,0,0,11.45,2.822l.041-.017a10,10,0,0,1,13.562,7.118l.007.034a10,10,0,0,0,8.829,7.821l.038,0a10,10,0,0,1,8.7,12.608l-.007.026A10,10,0,0,0,118.99,50.6l.024.016a10,10,0,0,1,1.847,15.209l-.018.019a10,10,0,0,0-1.422,11.713l.012.022A10,10,0,0,1,114,91.9l-.031.011a10,10,0,0,0-6.7,9.708v.03A10,10,0,0,1,95.8,111.805l-.041-.006a10,10,0,0,0-10.443,5.48l-.017.035a10,10,0,0,1-14.87,3.665l-.036-.026a10,10,0,0,0-11.792,0l-.036.026a10,10,0,0,1-14.87-3.665l-.017-.035a10,10,0,0,0-10.443-5.48l-.041.006a10,10,0,0,1-11.465-10.158v-.03a10,10,0,0,0-6.7-9.708L15,91.9A10,10,0,0,1,9.567,77.574l.012-.022A10,10,0,0,0,8.157,65.839l-.018-.019A10,10,0,0,1,9.986,50.611l.024-.016a10,10,0,0,0,4.184-11.031l-.007-.026a10,10,0,0,1,8.7-12.608l.038,0a10,10,0,0,0,8.829-7.821l.007-.034a10,10,0,0,1,13.562-7.118l.041.017A10,10,0,0,0,56.815,9.15Z",
    transform: "translate(43 199)",
    fill: "#fc4b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "social-media",
    transform: "translate(-477.769 -297.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M1235.515,1836.62l1.808-1.015,3.593-3.713-7.036-4.135-6.324,3.919c-2.438,1.859-1.866,3.184-.892,4.359a6.173,6.173,0,0,0,3.494,1.421A8.6,8.6,0,0,0,1235.515,1836.62Z",
    transform: "translate(-674.869 -1279.517)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M1374.854,1836.62l1.808-1.015,3.593-3.713-7.036-4.135-4.946,3.065c-1.377.854,1.225,6.633,2.717,6.737A7.5,7.5,0,0,0,1374.854,1836.62Z",
    transform: "translate(-814.208 -1279.517)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M1213.724,2682.809l1.935-.746,7.42-1.45-7.462-6.887-3.974,2-5.885,2.965a1.468,1.468,0,0,0-.63,2.165C1207.245,2684,1210.185,2684.173,1213.724,2682.809Z",
    transform: "translate(-654.318 -2109.311)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M1651.782,2681.853l6.344-1.24-7.462-6.887-2.26,1.139C1648.442,2677.274,1648.581,2680.167,1651.782,2681.853Zm6.749,12.244,1.707-1.178,3.233-4.031-7.389-3.464-5.932,4.489c-2.255,2.077-1.562,3.344-.483,4.422S1655.41,2696.251,1658.532,2694.1Z",
    transform: "translate(-1089.365 -2109.311)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M1662.673,3399.261l-3.061,2.316c-2.255,2.077-1.744,3.814-.483,4.673,3.133,2.134,7.751.131,7.751.131C1664.031,3405.139,1662.673,3402.035,1662.673,3399.261Z",
    transform: "translate(-1098.827 -2820.975)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M2517.708,2303.083l20.514-3.411-19.445-25.926-16.835,19.974,5.782,3.434-3.192,1.007,1.454,5.808v5.722a3.621,3.621,0,0,0,3.458,1.439h0a5.154,5.154,0,0,0,3.322-5.359l-.256-2.468,3.545-1.2Z",
    transform: "translate(-1926.585 -1716.978)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M2994.373,2233.013l-15.1-1.21v-23.536h12.84C2991.463,2216.911,2993.057,2225.1,2994.373,2233.013Z",
    transform: "translate(-2394.789 -1652.751)",
    fill: "#368181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M1189.027,765.013l-18.048,3.779c-4.595.964-6.156-1.394-7.154-3.638L1143.9,715.4c-1.144-3.388,1.013-5.254,3.709-5.705l18.842-2.68c3.335-.7,4.1-.111,5.4,2.878l20.366,47.539C1194.312,762.3,1191.985,764.3,1189.027,765.013Z",
    transform: "translate(-594.197 -179.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M1128.966,729.693a5.821,5.821,0,0,1-3.4-.978,7.586,7.586,0,0,1-2.5-3.349l-.011-.027-19.935-49.771-.007-.02a4.929,4.929,0,0,1,.25-4.263,5.655,5.655,0,0,1,4.071-2.464l.019,0,18.817-2.677c1.632-.339,2.934-.442,3.982.146.978.549,1.574,1.586,2.273,3.19L1152.9,717.02c1.01,2.348,1.138,4.307.379,5.823a5.775,5.775,0,0,1-4.1,2.825l-.023.005-18.048,3.779A10.422,10.422,0,0,1,1128.966,729.693Zm-4.46-4.949c.927,2.081,2.177,4.035,6.272,3.176l18.036-3.776a4.309,4.309,0,0,0,3.061-2c.542-1.084.4-2.6-.418-4.505l-20.366-47.54a5.145,5.145,0,0,0-1.6-2.446c-.538-.3-1.384-.294-2.921.027l-.05.009-18.832,2.679a4.136,4.136,0,0,0-2.977,1.723,3.441,3.441,0,0,0-.117,2.938Z",
    transform: "translate(-554.157 -139.839)",
    fill: "#368181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M1241.483,695.054l-17.477,3.622c-4.6.964-6.156-1.394-7.154-3.638l-19.578-48.621c-1.144-3.388.664-5.357,3.359-5.809l18.842-3.707c3.335-.7,4.1-.111,5.4,2.878l19.307,47.831C1246.279,692.481,1244.441,694.34,1241.483,695.054Z",
    transform: "translate(-646.518 -111.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M1181.966,661.7a5.821,5.821,0,0,1-3.4-.978,7.584,7.584,0,0,1-2.5-3.349l-.011-.026L1156.473,608.7l-.007-.021a4.792,4.792,0,0,1,3.961-6.829l18.388-3.618c1.641-.342,3.191-.536,4.243.055a6.331,6.331,0,0,1,2.471,3.191l.008.019,19.3,47.824c1.085,2.525,1.25,4.474.508,5.959a5.2,5.2,0,0,1-3.748,2.546l-.025.006-17.477,3.622A10.415,10.415,0,0,1,1181.966,661.7Zm-4.46-4.95c.927,2.081,2.179,4.036,6.272,3.177l17.466-3.62a3.763,3.763,0,0,0,2.7-1.722c.517-1.034.333-2.6-.549-4.649l-.007-.016-19.3-47.822a5.749,5.749,0,0,0-1.7-2.406c-.538-.3-1.279-.329-2.816-.008l-.009,0-18.863,3.711a3.692,3.692,0,0,0-2.662,1.568,3.766,3.766,0,0,0-.093,3.2Z",
    transform: "translate(-606.451 -73.182)",
    fill: "#368181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M1259.1,677.067l-18.617,3.661c-2.782.671-3.255,2.265-2.527,4.723l.161.4,26.43-5.366-.443-1.1C1262.785,676.634,1262.157,676.295,1259.1,677.067Z",
    transform: "translate(-686.46 -150.473)",
    fill: "#daf7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M2267.858,3376.381l26.453-5.385c1.035,2.747.513,4.727-2.542,5.375l-17.466,3.62C2270.1,3380.836,2268.949,3378.995,2267.858,3376.381Z",
    transform: "translate(-1696.975 -2793.25)",
    fill: "azure"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M2332.313,3389.141l1.53,3.731a6.415,6.415,0,0,0,3.682.128l17.466-3.619a3.675,3.675,0,0,0,2.7-1.721l-1.4-3.4Z",
    transform: "translate(-1760.198 -2806.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M1307.769,921.957l-26.453,5.385-19.229-47.755,26.43-5.366C1294.938,890.131,1301.4,906.024,1307.769,921.957Z",
    transform: "translate(-710.434 -344.211)",
    fill: "azure"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M1290.5,879.14l-26.434,5.369-1.981-4.92,26.43-5.366Z",
    transform: "translate(-710.432 -344.212)",
    fill: "#b3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M1359.51,949.171l-16.264,3.3a2.043,2.043,0,0,1-2.189-1.24,1.313,1.313,0,0,1,.934-1.874l16.262-3.3a2.045,2.045,0,0,1,2.19,1.24A1.313,1.313,0,0,1,1359.51,949.171Zm-22.558,3.5a2.458,2.458,0,0,1-.325-.572c-.345-.855-.1-1.655.544-1.786a1.853,1.853,0,0,1,1.792,1.312,2.124,2.124,0,0,1,.15.608,3.121,3.121,0,0,1,1.266.7,2.274,2.274,0,0,0-.152-1.22,3.012,3.012,0,0,0-3.227-1.829,1.937,1.937,0,0,0-1.377,2.764,2.948,2.948,0,0,0,.78,1.093A1.826,1.826,0,0,1,1336.951,952.674Z",
    transform: "translate(-782.385 -414.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M1505.495,1271.922l-23.984,4.878-8.222-20.416,23.97-4.869Zm5.059,12.534-23.993,4.884-4.137-10.274,23.986-4.879Zm3.147,7.833-23.986,4.883c-.917-2.294-1.387-3.447-2.313-5.744l23.994-4.885C1512.322,1288.84,1512.94,1290.064,1513.7,1292.289Z",
    transform: "translate(-917.597 -714.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M1583.929,1420.06a2.477,2.477,0,0,1-.326-.572c-.345-.855-.1-1.655.544-1.786a1.854,1.854,0,0,1,1.792,1.312,2.119,2.119,0,0,1,.149.608,3.121,3.121,0,0,1,1.266.7,2.277,2.277,0,0,0-.152-1.221,3.013,3.013,0,0,0-3.228-1.828,1.937,1.937,0,0,0-1.378,2.764,2.947,2.947,0,0,0,.78,1.093A1.83,1.83,0,0,1,1583.929,1420.06Zm9.229,22.034a2.476,2.476,0,0,1-.326-.572c-.344-.856-.1-1.656.545-1.787a1.853,1.853,0,0,1,1.793,1.311,2.134,2.134,0,0,1,.149.608,3.121,3.121,0,0,1,1.267.7,2.278,2.278,0,0,0-.152-1.221,3.013,3.013,0,0,0-3.23-1.828,1.939,1.939,0,0,0-1.379,2.766,2.949,2.949,0,0,0,.78,1.093A1.829,1.829,0,0,1,1593.158,1442.094Zm5.087,12.63a2.478,2.478,0,0,1-.326-.571c-.344-.856-.1-1.656.546-1.787a1.853,1.853,0,0,1,1.793,1.311,2.124,2.124,0,0,1,.149.608,3.125,3.125,0,0,1,1.267.7,2.276,2.276,0,0,0-.152-1.221,3.013,3.013,0,0,0-3.231-1.827,1.939,1.939,0,0,0-1.38,2.766,2.949,2.949,0,0,0,.779,1.093A1.833,1.833,0,0,1,1598.245,1454.725Zm13.955-18.453-14.728,3a.343.343,0,0,1-.368-.208.221.221,0,0,1,.157-.315l14.728-3a.343.343,0,0,1,.368.208A.221.221,0,0,1,1612.2,1436.272Zm-4.784,2.3-9.451,1.923a.342.342,0,0,1-.368-.208.221.221,0,0,1,.157-.315l9.451-1.923a.343.343,0,0,1,.368.208A.22.22,0,0,1,1607.416,1438.567Zm-11.89-23.108-7.359,1.5a.343.343,0,0,1-.368-.208.221.221,0,0,1,.157-.315l7.359-1.495a.343.343,0,0,1,.368.208A.22.22,0,0,1,1595.526,1415.459Zm5.716.161-12.583,2.557a.343.343,0,0,1-.368-.208.22.22,0,0,1,.157-.315l12.583-2.556a.343.343,0,0,1,.368.208A.22.22,0,0,1,1601.243,1415.62Zm13.051,33.889-11.788,2.4a.343.343,0,0,1-.368-.208.221.221,0,0,1,.157-.315l11.788-2.4a.343.343,0,0,1,.368.208A.22.22,0,0,1,1614.293,1449.509Z",
    transform: "translate(-1024.64 -874.583)",
    fill: "#b3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M1711.72,1651.629l-21.667,4.406-3.756-9.328,21.661-4.4Z",
    transform: "translate(-1126.533 -1097.61)",
    fill: "#87cbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M1704.429,1651.148l-14.376,4.886-3.757-9.328,21.661-4.4.719,1.782Z",
    transform: "translate(-1126.532 -1097.61)",
    fill: "#bdffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M1690.3,1650.288c-.1,2.3-.149,3.448-.249,5.747l-3.756-9.328,21.66-4.4Z",
    transform: "translate(-1126.533 -1097.61)",
    fill: "#87cbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M1740.106,1652.095l-1.163-2.888,8.443-4.42,12.211-2.482Z",
    transform: "translate(-1178.173 -1097.61)",
    fill: "#abf4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M2330.177,1801.123a2.709,2.709,0,0,1-1.927,3.867,4.215,4.215,0,0,1-4.518-2.557,2.71,2.71,0,0,1,1.927-3.867A4.216,4.216,0,0,1,2330.177,1801.123Z",
    transform: "translate(-1751.534 -1250.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M1793.971,1956.189l-7.388-4.479-1.309,1.288-8.159-.951-1.6,2.385,2.051,5.092Z",
    transform: "translate(-1214.046 -1401.099)",
    fill: "#67c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M1856.485,2010.933l-21.665,4.4,1.387,3.444,21.667-4.406Z",
    transform: "translate(-1272.217 -1459.19)",
    fill: "#b3ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M1856.485,2010.933l-21.665,4.4.459,1.139,21.5-4.825Z",
    transform: "translate(-1272.217 -1459.19)",
    fill: "#88e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M1903.99,2070.457c-6.868,2.423-14.136,3.85-21.207,5.544l21.667-4.406Z",
    transform: "translate(-1319.263 -1517.576)",
    fill: "#a0f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M1825.5,2092.136l-9.7,2.321-.5-1.249,12.875-1.942Z",
    transform: "translate(-1253.062 -1537.988)",
    fill: "#67c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M1825.982,2055.323a35.555,35.555,0,0,1-10.69,1.5,37,37,0,0,0,11.477-2.651l1.4.709Z",
    transform: "translate(-1253.062 -1501.599)",
    fill: "#56afaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M2349.138,1715.291c.831-1.834,1.247-2.751,2.078-4.585l2.452,1.228c.887-1.943,1.331-2.915,2.217-4.858l3.831,2.7c.5,1.244.753,1.865,1.255,3.109Z",
    transform: "translate(-1776.701 -1161.142)",
    fill: "#88e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M2610.734,1903.219l.66-1.456a1.411,1.411,0,0,1,1.983-.5c.139-.307.209-.46.35-.767a2.091,2.091,0,0,1,3.179-.493l.732,1.815Z",
    transform: "translate(-2033.296 -1349.89)",
    fill: "#67c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M2044.668,2024.719a96.767,96.767,0,0,1,17.727-4.218l.156.386Z",
    transform: "translate(-1478.052 -1468.575)",
    fill: "#67c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M2419.482,2672.431l-4.96,1.009a.214.214,0,0,1-.23-.129.138.138,0,0,1,.1-.2l4.96-1.009a.214.214,0,0,1,.23.13A.138.138,0,0,1,2419.482,2672.431Zm9.141-1.86-7.63,1.552a.213.213,0,0,1-.23-.13.138.138,0,0,1,.1-.2l7.63-1.552a.213.213,0,0,1,.23.13A.138.138,0,0,1,2428.623,2670.571Zm-5.967,2.411-7.631,1.553a.215.215,0,0,1-.23-.13.138.138,0,0,1,.1-.2l7.631-1.553a.215.215,0,0,1,.23.13A.138.138,0,0,1,2422.656,2672.982Zm1.278,10.34-4.961,1.01a.214.214,0,0,1-.229-.13.137.137,0,0,1,.1-.2l4.961-1.01a.214.214,0,0,1,.23.13A.138.138,0,0,1,2423.933,2683.322Zm9.145-1.862-7.633,1.554a.214.214,0,0,1-.23-.13.138.138,0,0,1,.1-.2l7.633-1.554a.214.214,0,0,1,.23.13A.138.138,0,0,1,2433.078,2681.459Zm-5.97,2.412-7.633,1.555a.214.214,0,0,1-.23-.13.138.138,0,0,1,.1-.2l7.634-1.554a.214.214,0,0,1,.23.13A.137.137,0,0,1,2427.108,2683.871Zm3.082.656-10.238,2.079a.215.215,0,0,1-.231-.131.139.139,0,0,1,.1-.2l10.235-2.083a.221.221,0,0,1,.234.135A.138.138,0,0,1,2430.189,2684.527Z",
    transform: "translate(-1840.597 -2105.893)",
    fill: "#daf7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M1897.143,2452.586a1.537,1.537,0,0,1-1.093,2.193,2.389,2.389,0,0,1-2.56-1.449,1.537,1.537,0,0,1,1.093-2.192A2.388,2.388,0,0,1,1897.143,2452.586Z",
    transform: "translate(-1329.625 -1890.94)",
    fill: "azure"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M1985.491,2500.064a.645.645,0,0,1,.941-.313c.593.336.233,1.44-.315,1.865Z",
    transform: "translate(-1420.007 -1938.561)",
    fill: "#ff8fab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M1930.725,2512.422c-.253-.143-.814-.348-1.031.088-.253.508.875,1.31,1.656,1.464Z",
    transform: "translate(-1365.241 -1950.918)",
    fill: "#ff8fab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M2162.264,3110.9a1.537,1.537,0,0,1-1.094,2.193,2.388,2.388,0,0,1-2.56-1.449,1.537,1.537,0,0,1,1.094-2.192A2.387,2.387,0,0,1,2162.264,3110.9Z",
    transform: "translate(-1589.676 -2536.667)",
    fill: "azure"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M2250.637,3158.369a.645.645,0,0,1,.941-.313c.594.335.232,1.44-.316,1.865Z",
    transform: "translate(-1680.083 -2584.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M2195.852,3170.74c-.253-.143-.814-.348-1.031.089-.253.508.875,1.309,1.656,1.463Z",
    transform: "translate(-1625.299 -2596.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M2960.611,2236.318a1.536,1.536,0,0,1-1.092,2.192,2.389,2.389,0,0,1-2.561-1.449,1.535,1.535,0,0,1,1.092-2.192A2.391,2.391,0,0,1,2960.611,2236.318Z",
    transform: "translate(-2372.761 -1678.807)",
    fill: "azure"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M3004.909,2284c.168.417-.142.844-.692.956a1.161,1.161,0,0,1-1.3-.551c-.168-.416.142-.845.692-.956A1.16,1.16,0,0,1,3004.909,2284Z",
    transform: "translate(-2417.934 -1726.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M2999.835,2342.622l-.327.6.9-.291Z",
    transform: "translate(-2414.637 -1784.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M3229.2,2901.985a1.536,1.536,0,0,1-1.093,2.192,2.39,2.39,0,0,1-2.562-1.448,1.536,1.536,0,0,1,1.093-2.192A2.389,2.389,0,0,1,3229.2,2901.985Z",
    transform: "translate(-2636.216 -2331.748)",
    fill: "azure"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M3273.513,2949.669c.168.416-.142.845-.693.957a1.16,1.16,0,0,1-1.3-.551c-.168-.416.142-.844.692-.957A1.162,1.162,0,0,1,3273.513,2949.669Z",
    transform: "translate(-2681.403 -2379.411)",
    fill: "#a4eded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M3268.428,3008.3c-.131.24-.2.361-.327.6l.9-.291Z",
    transform: "translate(-2678.095 -2437.487)",
    fill: "#a4eded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M1938.461,1524.663l-4.96,1.009a.215.215,0,0,1-.23-.13.138.138,0,0,1,.1-.2l4.96-1.009a.214.214,0,0,1,.23.13A.138.138,0,0,1,1938.461,1524.663Zm9.142-1.861-7.631,1.553a.215.215,0,0,1-.23-.13.138.138,0,0,1,.1-.2l7.631-1.553a.214.214,0,0,1,.23.13A.138.138,0,0,1,1947.6,1522.8Zm-5.968,2.411-7.632,1.553a.214.214,0,0,1-.229-.13.138.138,0,0,1,.1-.2l7.632-1.553a.215.215,0,0,1,.23.13A.138.138,0,0,1,1941.635,1525.214Zm3.073.646-10.231,2.083a.214.214,0,0,1-.23-.13.138.138,0,0,1,.1-.2l10.231-2.083a.214.214,0,0,1,.23.13A.138.138,0,0,1,1944.708,1525.86Zm-16.531-25.815-4.956,1.007a.214.214,0,0,1-.229-.13.138.138,0,0,1,.1-.2l4.956-1.007a.214.214,0,0,1,.23.13A.138.138,0,0,1,1928.177,1500.045Zm9.135-1.856-7.625,1.549a.214.214,0,0,1-.23-.13.138.138,0,0,1,.1-.2l7.625-1.549a.214.214,0,0,1,.23.13A.138.138,0,0,1,1937.312,1498.189Zm-5.964,2.408-7.625,1.55a.214.214,0,0,1-.23-.13.138.138,0,0,1,.1-.2l7.626-1.55a.215.215,0,0,1,.23.13A.138.138,0,0,1,1931.349,1500.6Z",
    transform: "translate(-1358.689 -955.925)",
    fill: "#daf7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(565.728 540.274)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M1998.247,1441.061l1.768,4.391,15.465-32.626-.714-1.769Z",
    transform: "translate(-1998.247 -1411.057)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(579.109 556.439)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M2716.516,2278.246c-1.929-.608-5.858-5.562-6.593-9.068a5.927,5.927,0,0,0-2.437-3.736c-1.683-1.13-3.594-1.165-6.527-1.283l-2.82-.114,9.662-7.523Z",
    transform: "translate(-2698.139 -2256.522)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612",
    transform: "translate(551.169 527.831)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M1251.9,760.225l-13.657,10.04-1.168-2.9c-.938-2.727.274-4.354,2.527-4.723Z",
    transform: "translate(-1236.758 -760.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M2510.759,1878.358a3.172,3.172,0,0,0-.19.285l-3.794,6.512-3.7,4.825a1.286,1.286,0,0,0,.419,1.919l.8.423a6.792,6.792,0,0,0,8.508-1.8l2.268-2.874,6.7,2.194c-1.185,5.224,2.993,11.322,5.186,14.186,4.008,5.008,1.154,9.436-6.019,11.066l3.947.607a17.743,17.743,0,0,0,5.358,1,5.666,5.666,0,0,0,2.029-.351l6.805-2.6,11.48,3.05v-17.481C2526.915,1899.641,2530.8,1875.765,2510.759,1878.358Z",
    transform: "translate(-1927.433 -1328.957)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M2524.26,2220.974a2.159,2.159,0,0,0-2.57-.029l-3.7,4.825.314.13a2.9,2.9,0,0,0,3.352-.847l2.652-3.255A.607.607,0,0,0,2524.26,2220.974Z",
    transform: "translate(-1942.324 -1664.785)",
    fill: "#deffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M3462.065,3243.6l3.344-1.278a11.974,11.974,0,0,1,7.066-.459l4.011.961-3.935-2.516a6.261,6.261,0,0,0-7.248.356Zm-2.029.351c-.115-2.9,1.722-7.669-3.287-12.678,2.938,5.028,1.154,9.436-6.019,11.066C3450.731,3242.335,3457.491,3243.923,3460.036,3243.947Z",
    transform: "translate(-2857.233 -2656.194)",
    fill: "#ffb764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M2701.9,2209.7a2.765,2.765,0,0,0-2.8-.733c-.47.091-.271.81.2.718.589-.115,1.551-.152,1.964.39C2701.545,2210.448,2702.192,2210.077,2701.9,2209.7Z",
    transform: "translate(-2119.705 -1653.348)",
    fill: "azure"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleTips1);
export default __webpack_public_path__ + "static/media/sale-tips-1.81398fc38fa36cc3e49e647ce39726f7.svg";
export { ForwardRef as ReactComponent };